import { Action, ActionType } from 'typed/actions';
import { IReducer } from './';
import { Entity, NetworkArray, NetworkPaginationSlice, entityLoadAllReducer, inexpirableReducers } from './entityReducers';
import { SystemEnumerationEntity } from 'typed/api/entities';

type EntityBase = SystemEnumerationEntity<any>;

type PID<S> =
    S extends NetworkPaginationSlice<infer e> ? e['ID'] :
    S extends NetworkArray<infer e> ? e['ID'] :
    S extends Entity[] ? Entity['ID'] :
    never;

export default function synchronizableEnumReducer<E extends EntityBase, S extends NetworkPaginationSlice<E>, T extends ActionType>(def: S, type: T, ensureSyncWith: { [k: string]: PID<S>; }, entityName: string): IReducer<S, Action<T>>;
export default function synchronizableEnumReducer<E extends EntityBase, S extends NetworkArray<E>, T extends ActionType>(def: S, type: T, ensureSyncWith: { [k: string]: PID<S>; }, entityName: string): IReducer<S, Action<T>>;
export default function synchronizableEnumReducer<E extends EntityBase, S extends E[], T extends ActionType>(def: S, type: T, ensureSyncWith: { [k: string]: PID<S>; }, entityName: string): IReducer<S, Action<T>> {
    const
        lr = entityLoadAllReducer<E, S, any>(def, type, ensureSyncWith, entityName),
        ir = inexpirableReducers(def, lr);

    return function synchronizableEnumReducer(state: S | undefined, action: Action<T>) {
        return ir(state, action);
    };
}
